import { render, staticRenderFns } from "./ClientDashboardPage.vue?vue&type=template&id=9afe37da&"
import script from "./ClientDashboardPage.vue?vue&type=script&lang=js&"
export * from "./ClientDashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboardPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports